<script>
import AnsoButtonGroup from '../../components-comm/anso-button-group'
export default {
  name: 'DateCombination',
  model: {
    prop: 'value',
    event: 'input',
  },
  components: {
    AnsoButtonGroup,
  },
  props: {
    value: {
      type: [Object, String, Date, Number],
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '请选择日期',
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'small',
    },
    editable: {
      type: Boolean,
      default: true,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    pickerOptions: {
      type: Object,
      default: () => ({}),
    },
    align: {
      type: String,
      default: 'left',
    },
    popperClass: {
      type: String,
      default: '',
    },
    rangeSeparator: {
      type: String,
      default: '-',
    },
    startPlaceholder: {
      required: false,
      type: String,
      default: '开始日期',
    },
    endPlaceholder: {
      required: false,
      type: String,
      default: '结束日期',
    },
    defaultValue: {
      type: [Date, String],
      default: '',
    },
    valueFormat: {
      type: String,
      default: 'timestamp',
    },
    // 此属性用来控制返回值value的类型，默认使用对象返回{ type: 'date', dateTime: 1745769600000 } 否则返回 1745769600000
    valueType: {
      type: String,
      default: 'single', // multiple | single
    },
    event: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    calcFormat() {
      if (this.active === 'date') {
        return 'yyyy-MM-dd'
      } else if (this.active === 'month') {
        return 'yyyy-MM'
      } else {
        return 'yyyy'
      }
    },
  },
  created() {},
  data() {
    return {
      active: 'date',
      dateValue: '',
      btns: [
        {
          label: '日',
          value: 'date',
        },
        // {
        //   label: '周',
        //   name: 'week'
        // },
        {
          label: '月',
          value: 'month',
        },
        // {
        //   label: '季',
        //   value: 'quarter'
        // },
        {
          label: '年',
          value: 'year',
        },
      ],
    }
  },
  methods: {
    onValueChange() {
      if (this.valueType === 'multiple') {
        this.$emit('input', {
          type: this.active,
          dateValue: this.dateValue,
        })
      } else {
        this.$emit('input', this.dateValue)
      }
    },
    generateDatePicker() {
      let {
        placeholder,
        clearable,
        pickerOptions,
        align,
        popperClass,
        rangeSeparator,
        startPlaceholder,
        endPlaceholder,
        defaultValue,
        valueFormat,
        disabled,
        readonly,
        size,
      } = this
      return (
        <el-date-picker
          v-model={this.dateValue}
          props={{
            type: this.active,
            clearable,
            pickerOptions,
            align,
            popperClass,
            rangeSeparator,
            'start-placeholder': startPlaceholder,
            'end-placeholder': endPlaceholder,
            defaultValue,
            valueFormat,
            disabled,
            readonly,
            size,
            format: this.calcFormat,
          }}
          on={{
            ...this.event,
            change: (val) => {
              this.dateValue = val
              this.onValueChange()
            },
          }}
          style={{ marginLeft: '10px' }}
        ></el-date-picker>
      )
    },
  },
  render() {
    let { btns } = this
    return (
      <div class="date-combination">
        <AnsoButtonGroup
          isAdaptive
          v-model={this.active}
          props={{
            btns,
          }}
          onClick={(item) => {
            this.dateValue = ''
            this.active = item.value
            this.onValueChange()
          }}
        />
        {this.generateDatePicker()}
      </div>
    )
  },
}
</script>

<style lang="scss" scoped>
.date-combination {
  display: inline-flex;
  align-items: center;
}
</style>
